import "../Dashboard/dashboard.css"
import React, { useEffect, useState } from 'react';
import Topbar from '../../components/Topbar';
import Leftbar from '../../components/Leftsidebar';
import { Link } from 'react-router-dom';
import { Tooltip } from 'react-tooltip'
import { getTcPathwayList, usTimezone } from "../Utils/utils";
import Loaderspinner from "../../components/Loader";
import ReactPaginate from 'react-paginate';
import { Row, Col } from "react-bootstrap";

const TcPathway = () => {
    const [showSidebar, setShowSidebar] = useState(false);
    const [tcPathwayList, setTcPathwayList] = useState([]);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (search.length == 0 || search.length >= 3) {
            fetchList();
        }
    }, [page, search]);

    const fetchList = async () => {
        try {
            setLoading(true)
            const limit = 10;
            const offset = page * limit;

            const response = await getTcPathwayList({
                search,
                limit,
                offset,
            });
            setTcPathwayList(response?.data || []);
            if ((response?.data?.length || 0) < limit) {
                setTotalPages(page + 1);
            } else {
                setTotalPages(page + 2);
            }
        } catch (error) {
            console.error("Error fetching tc pathway list:", error);
        } finally {
            setLoading(false)
        }
    };


    const handleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleSidebarClose = () => {
        setShowSidebar(false);
    };

    const STATUS_CONFIG = {
        pending: {
            label: "Pending Outreach",
            color: "#F29339",
        },
        accepted: {
            label: "Accepted Tactical TC",
            color: "#00c04b",
        },
        rejected: {
            label: " Rejected Tactical TC",
            color: "#FF0000",
        },
        default: {
            label: "No Status",
            color: "#9e9fa2",
        },
    };

    const getStatusConfig = (status) => {
        return STATUS_CONFIG[status] || STATUS_CONFIG.default;
    };

    return (
        <>
            {loading && <Loaderspinner />}
            <div className="g-sidenav-show bg-gray-100 min-vh-100">
                <div id="wrapper">
                    <Leftbar showSidebar={showSidebar} handleSidebarClose={handleSidebarClose} />
                    <main className="main-content border-radius-lg">
                        <Topbar handleSidebar={handleSidebar} />
                        <div className="header header-bg-lender pt-3">
                            <div className="col-lg-6 col-7">
                                <nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4" style={{ marginLeft: '30px' }}>
                                    <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                                        <li className="breadcrumb-item"><Link to="/dashboard"><i className="fas fa-home" /></Link></li>
                                        <li className="breadcrumb-item mt-2"><span className='' style={{ color: "#f6f9fc" }}>TC Purchases</span></li>
                                    </ol>
                                </nav>
                            </div>

                        </div>
                        <div className="container-fluid mt--6">
                            <div className="row">
                                <div className="col">
                                    <div className="card">
                                        <div className="card-header border-0">
                                            <div className="d-flex justify-content-between">
                                                <div className="row ">
                                                    <h5 className="mb-0 w-auto">TC Purchases</h5>
                                                    {/* <p
                                                        className="w-auto px-0"
                                                        data-tooltip-id="my-tooltip"
                                                        data-tooltip-content="A complete list of all projects created by borrowers. Use this report to review project details, check status, and ensure projects comply with platform guidelines."
                                                        data-tooltip-place="right"
                                                    >
                                                        <i className="fas fa-info-circle" />

                                                    </p>

                                                    <Tooltip id="my-tooltip" style={{ width: '30%' }} /> */}
                                                </div>
                                                <div>
                                                    <input
                                                        type="text"
                                                        className="search-input mx-2"
                                                        placeholder="Search"
                                                        value={search}
                                                        onChange={(e) => setSearch(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table align-items-center table-flush">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th>Project Details</th>
                                                        <th>Borrower Details</th>
                                                        <th>Lender details</th>
                                                        <th>TC Details</th>
                                                        <th>Secured At</th>
                                                        <th>Admin Fee</th>
                                                        <th>Status</th>
                                                        {/* <th>Action</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {tcPathwayList?.length > 0 ? (
                                                        tcPathwayList.map((tc, index) => (
                                                            <tr key={index}>
                                                                <td className="table-user">
                                                                    <div className="d-flex flex-column gap-1" style={{ width: "140px" }}>
                                                                        <span>{tc.project_name}</span>
                                                                        <span>{tc.capital_partner}</span>
                                                                    </div>
                                                                </td>
                                                                <td className="table-user">
                                                                    <div className="d-flex flex-column gap-1" style={{ width: "120px" }}>
                                                                        <span>
                                                                            {`${tc?.user?.about.name} ${tc?.user?.about.lastname}`}
                                                                        </span>
                                                                        <span>
                                                                            {tc?.user?.phone}
                                                                        </span>
                                                                    </div>
                                                                </td>

                                                                <td className="table-user">
                                                                    <div className="d-flex flex-column gap-1" style={{ width: "120px" }}>
                                                                        <span>
                                                                            {`${tc?.funder?.about.name} ${tc?.funder?.about.lastname}`}
                                                                        </span>
                                                                        <span>
                                                                            {tc?.funder?.phone}
                                                                        </span>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div style={{ width: "180px" }}>
                                                                        {tc?.transaction_cordinator
                                                                            ? <div className="d-flex flex-column gap-1">
                                                                                <span>{`${tc.transaction_cordinator.first_name} ${tc.transaction_cordinator.last_name}`}</span>
                                                                                <span>{tc.transaction_cordinator.email}</span>
                                                                            </div>
                                                                            : "Not assigned"}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div style={{ width: "150px" }}>
                                                                        {tc?.secured_at ? usTimezone(tc.secured_at) : ' '}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div style={{ width: "75px" }}>
                                                                        {tc?.raiser_tc ?
                                                                            "Paid" : "Not paid"}
                                                                    </div> 
                                                                </td>

                                                                <td className="table-user">
                                                                    <div
                                                                        style={{
                                                                            display: "inline",
                                                                            backgroundColor: getStatusConfig(tc?.assigned_tc_status).color,
                                                                            borderRadius: "12px",
                                                                            padding: "6px 16px",
                                                                            fontWeight: 600,
                                                                            color: "#fff"
                                                                        }}
                                                                    >
                                                                        {getStatusConfig(tc?.assigned_tc_status).label}
                                                                    </div>
                                                                </td>
                                                                {/* <td>
                                                            <div style={{ width: "150px" }}>
                                                                <button className="viewproject-btn pull-right mb-1">
                                                                    <span className="text-white">Mark as Coordinator</span>
                                                                </button>
                                                            </div>
                                                        </td> */}
                                                            </tr>
                                                        ))) :
                                                        <tr>
                                                            <td colSpan="10" className="text-center"><b>No records found</b></td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Row>
                                <Col xs={12}>
                                    <div className='paginate-css'>
                                        <ReactPaginate
                                            previousLabel="<"
                                            nextLabel=">"
                                            breakLabel="..."
                                            pageCount={totalPages}
                                            marginPagesDisplayed={1}
                                            pageRangeDisplayed={2}
                                            onPageChange={({ selected }) => setPage(selected)}
                                            containerClassName="pagination"
                                            activeClassName="active"
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </main>
                </div>
            </div>
        </>

    );
};

export default TcPathway;
